import React from "react";
import StepSlider from "../../components/StepSlider";
import { StyledDescriptions, StyledSectionWrapper, StyledTitle } from "./ui";

const sliderData = [
  {
    title: "Search",
    image: "slider1-1.png",
    description:
      "Search sports or activities, Discover Venues, View classes and find personal trainers in your area and beyond"
  },

  {
    image: "Section-1---2.png",
    title: "Book",
    description:
      "Book instantly through exsportia see all you past and upcoming bookings. "
  },

  {
    image: "Section-1---3.png",
    title: "Pay",
    description: "Pay directly using credit card, PayPal, apple pay +more"
  },
  {
    image: "Section-1---4.png",
    title: "Play",
    description: "Arrive, scan your reservation and play"
  }
];

const ExsportiaFeatures = () => {
  return (
    <StyledSectionWrapper id="ExsportiaFeatures">
      <StyledTitle>Exsportia Application</StyledTitle>
      <StyledDescriptions
        fontSize={["28px", null, null, "32px"]}
        lineHeight={["35px", null, null, "44px"]}
      >
        Exsportia makes 1000+ Sports and Activities bookable at your fingertips
      </StyledDescriptions>
      <StepSlider data={[...sliderData]} color="mainPink" />
    </StyledSectionWrapper>
  );
};

export default ExsportiaFeatures;
